import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RlFile } from '../../file/shared/rl-file';
import { FileService } from '../../file/core/file.service';
import { UtilsService } from '../../shared/core/utils.service';

@Component({
  selector: 'rl-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss','./content-preview.component-rtl.css']
})
export class ContentPreviewComponent {
  @Input() set content(content : RlFile){
    this._content=content;
    this.initUrl();
  };

  @Input() view? : boolean = true;  //mode view Download hide  default=View
  @Output() onContentLoad? = new EventEmitter<any>();
  @Output() onClick : EventEmitter<string> = new EventEmitter<string>();
  _content : RlFile;
  constructor(private fileService : FileService,private utils : UtilsService) {}

  initUrl(): void {
    if(!this._content?.url){
      //this.fileService.getLinkTofile(this._content).subscribe(url => this._content.url = url['URL']);
    }
  };
  
  download(): void{
    this.onClick.emit('download');
  };

  openInNewTab(): void{
    this.onClick.emit('openInNewTab');
  };
  
  
}


